import React from "react";
import HelpCard from "../../Components/Footer/HelpCenterCard/HelpCard";
import FaqComponent from "../../Components/Footer/FaqComponent/FaqComponent";
import ServicesCardSection from "../ItPage/ServicesCardSection/ServicesCardSection";
import BgvStepsSection from "../ItPage/BgvStepsSection/BgvStepsSection";
import BgvServiceSection from "../ItPage/BgvServiceSection/BgvServiceSection";
import BrandCarousel from "../ItPage/BrandCarousel/BrandCarousel";
import ButtonComponent from "../../Components/Buttons/ButtonComponent";
import { Helmet } from "react-helmet";
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";
const Travel_img = `${digitalOceanURL}/Sector/Travel.png`;
const bg_image = `${digitalOceanURL}/About_Us_img/About_bg.png`;

export default function Travel() {
  return (
    <>
      <Helmet>
        <title>
          Verification&Onboarding Solution for Travel & Hospitality
          Hirestar.io
        </title>
        <meta
          name="description"
          content="Verify travel agencies and agents instantly with our industry-specific due diligence solution. Prevent fraud, ensure compliance, and streamline onboarding."
        />
        <meta
          name="keywords"
          content="hospitality employee verification, travel staff background checks, hotel hiring compliance, tour operator verification, identity checks hospitality, vendor onboarding solutions, social media verification, professional reference verification, police verification, indian court record, passport verification, education verification"
        />
        <meta property="og:site_name" content="HireStar.io" />
        <link
          rel="canonical"
          href={`https://hirestar.io${window.location.pathname}`}
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:title" content="Travel and Hospitality" />

        <meta
          property="og:title"
          content="Verification & Onboarding Solution for Travel & Hospitality |
          Hirestar.io"
        />
        
        <meta name="robots" content="index, follow" />
        <meta
          property="og:description"
          content="Verify travel agencies and agents instantly with our industry-specific due diligence solution. Prevent fraud, ensure compliance, and streamline onboarding."
        />
        <meta
          property="og:url"
          content="https://hirestar.io/industries/travel"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={Travel_img} />
        <meta property="og:image:type" content="image/png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Verification & Onboarding Solution for Travel & Hospitality |
          Hirestar.io"
        />
        <meta
          name="twitter:description"
          content="Verify travel agencies and agents instantly with our industry-specific due diligence solution. Prevent fraud, ensure compliance, and streamline onboarding."
        />
        <meta name="twitter:image" content={Travel_img} />
      </Helmet>
      <div className=" relative  background_color bottom_space">
        {/* Image that is hidden on small screens */}
        <img
          src={bg_image}
          alt="travel sector hero img"
          className="absolute  object-cover w-full lg:h-[150%] h-[110%] md:h-[120%] bg_curve_img"
        />

        <div className="mb-16 relative  w-full h-full md:top-28 lg:top-0">
          <div className="grid grid-cols-12 gap-4 justify-items-center relative top-0 lg:top-32 lg:mx-20 xl:mx-32 2xl:mx-40 items-center">
            {/* Text container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-7 w-full Banking_heading font-semibold font-[poppins] top_spacing ">
              <span className="industry_info">Travel</span>
              <h1 className="w-full text-[32px] md:text-[40px] lg:text-[46px]">
                Facilitate travel with trust, ensuring your customers feel safe
                and valued.
              </h1>
              <h2 className="about-text-para mt-2">
                Unlock fast and reliable employee verification and third-party
                due diligence solutions today, ensuring seamless travel with
                complete trust and confidence.
              </h2>

              {/* Button Group */}
              <div className="mt-4">
                <ButtonComponent
                  arialLabel={
                    "Get in touch with an expert for Facilitate travel with trust, ensuring your customers feel safe and valued"
                  }
                />
              </div>
            </div>

            {/* Image container */}
            <div className="col-span-12 md:col-span-12 lg:col-span-5 relative   lg:top-8 ">
              <img
                src={Travel_img}
                alt="about-girl img for travel sector"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="lg:mt-[24rem] md:mt-[12rem] mt-[8rem]">
        <BrandCarousel />
      </div>
      {/* 3 section */}
      <BgvServiceSection Sector="Travel Sector" />
      {/* 4 section */}
      {/*  <BgvStepsSection /> */}
      {/* 5 section */}
      <ServicesCardSection Sector="Travel Sector" Sector_cards="travel" />
      <div className="mb-48">{<BgvStepsSection />}</div>
      <FaqComponent />
      <div className="relative top-28  left-0 right-0">
        <HelpCard />
      </div>
    </>
  );
}
